import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const labelMap = {
  marketing: 'Marketing',
  reports: 'Reports'
};

const UpcomingFeature = () => {
  const navigate = useNavigate();
  const { feature = '' } = useParams();
  const niceLabel = labelMap[feature] || 'This feature';

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
        {niceLabel}
      </Typography>
      <Typography variant="h6" sx={{ opacity: 0.9, mb: 2 }}>
        Coming soon
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        We’re putting the final touches on {niceLabel.toLowerCase()}. Check back shortly!
      </Typography>
      <Button variant="contained" onClick={() => navigate('/dashboard')}>
        Back to Dashboard
      </Button>
    </Box>
  );
};

export default UpcomingFeature;


